import axios from 'axios';
import router from '../../../routes/index';
import { getItem } from '../../utility/localStorageControl';
import { ElNotification } from 'element-plus';
// import { MasterKeys } from '../../../public/envConfig/index.js';
// import { MasterKeys } from '../../plugins/envConfig.js';
// let appEnv = process.env.NODE_ENV || 'development';
// const API_ENDPOINT = MasterKeys[appEnv].apiEndPoint;
const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

const authHeader = () => ({
	Authorization: `Bearer ${getItem('access_token')}`
});

const client = axios.create({
	baseURL: API_ENDPOINT,
	headers: {
		'Accept-Language': localStorage.getItem('lang') || 1,
		'Language': localStorage.getItem('lang') || 1,
		'Content-Type': 'application/json'
	}
});

class DataService {
	static get(path = '') {
		return client({
			method: 'GET',
			url: path,
			headers: { ...authHeader() }
		});
	}

	static post(path = '', data = {}, optionalHeader = {}) {
        let headers;
        if(path == '/auth/login'){
            headers = { ...optionalHeader }
        }else{
            headers =  { ...authHeader(), ...optionalHeader }
        }
		return client({
			method: 'POST',
			url: path,
			data,
			headers
		});
	}

	static patch(path = '', data = {}) {
		return client({
			method: 'PATCH',
			url: path,
			data: JSON.stringify(data),
			headers: { ...authHeader() }
		});
	}

	static delete(path = '', data = {}) {
		return client({
			method: 'DELETE',
			url: path,
			data: JSON.stringify(data),
			headers: { ...authHeader() }
		});
	}

	static put(path = '', data = {}, optionalHeader = {}) {
        //remove unpublished language
        // let allTranslates = data.translates;
        // let newTranslates = []
        // if (allTranslates){
        //     for (let index = 0; index < publishedLanguages.length; index++) {
        //         const element = publishedLanguages[index];
        //         let existTranslate = allTranslates.find(lang =>lang.languageID == element.id);
        //         if(existTranslate){
        //             newTranslates.push(existTranslate)
        //         }
        //     }
        //     data.translates = newTranslates;
        // }
		return client({
			method: 'PUT',
			url: path,
			data,
			headers: { ...authHeader(), ...optionalHeader }
		});
	}
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */

client.interceptors.request.use(config => {
	// do something before executing the request
	// For example tag along the bearer access token to request header or set a cookie
	const requestConfig = config;
    const { headers } = config;
	requestConfig.headers = {
		...headers,
		// Authorization: `Bearer ${getItem('access_token')}`
	};

	return requestConfig;
});

client.interceptors.response.use(
	response => {
        //handle error after success handshake
        if (response.data.status != 1) {
            ElNotification({
                title: 'something wrong',
                message: response.data.message,
                type: 'error',
            });
        }
		return response;
	},
	error => {
		/**
		 * Do something in case the response returns an error code [3**, 4**, 5**] etc
		 * For example, on token expiration retrieve a new access token, retry a failed request etc
		 */
		const { response } = error;
        // const originalRequest = error.config;
      
        
		if (response) {
			if (response.status == 401) {
				localStorage.removeItem('awsatLoggedIn');
                localStorage.removeItem('access_token');
                localStorage.removeItem('adminStore');

                router.push('/admin');
                ElNotification({
                    title: 'session expired',
                    message: 'you need to login again',
                    type: 'error',
                });
			}
			else {
				// do something here , show error message with description
				ElNotification({
					title: response.status,
					message: response.data.message,
					type: 'error',
				});
				return response;
			}
		}
		return Promise.reject(error);
	}
);
export { DataService };
